import React from "react";
import { TableProPlus, TableSettingIcon } from "@gw/web-basic-components";
import type {
  TableProPlusRef,
  TableProPlusProps,
} from "@gw/web-basic-components";
import filterValueHelper from "./filter-value-helper";
import type { GWTableProPlusProps } from "./dto";
import RefreshIcon from "./refresh-icon";

const {
  Order,
  MatchType,
  FilterDisplayPanel,
  isFilterTypeValue,
  isOrderTypeValue,
  useFilterValue,
  useFilterValueToString,
} = TableProPlus;

const GWTableProPlus = <T extends {}>(
  props: React.PropsWithChildren<GWTableProPlusProps<T>>,
  ref: React.ForwardedRef<TableProPlusRef>
) => {
  const { onChange, ...rest } = props;

  const handleChange: TableProPlusProps<any>["onChange"] = (state) => {
    onChange?.(filterValueHelper.toApi(state), state);
  };
  return (
    <TableProPlus ref={ref} {...rest} onChange={handleChange}></TableProPlus>
  );
};

const GWTableProPlusRef = React.forwardRef(GWTableProPlus) as unknown as (<
  T extends {}
>(
  props: React.PropsWithChildren<GWTableProPlusProps<T>> & {
    ref?: React.ForwardedRef<TableProPlusRef>;
    key?: React.Key;
  }
) => React.ReactElement<any, any> | null) & {
  /** 表格页面刷新组件 */
  RefreshIcon: typeof RefreshIcon;
  /** 表格列表设置组件 */
  TableSettingIcon: typeof TableSettingIcon;
  /** 表格页面，统一展示已经筛选过条件 */
  FilterDisplayPanel: typeof FilterDisplayPanel;
  /** 获取筛选值，更新筛选值，提交筛选更改 */
  useFilterValue: typeof useFilterValue;
  /** 修改筛选条件展示面板中matchValue值展示 */
  useFilterValueToString: typeof useFilterValueToString;
  MatchType: typeof MatchType;
  Order: typeof Order;
  isFilterTypeValue: typeof isFilterTypeValue;
  isOrderTypeValue: typeof isOrderTypeValue;
};

GWTableProPlusRef.RefreshIcon = RefreshIcon;
GWTableProPlusRef.TableSettingIcon = TableSettingIcon;
GWTableProPlusRef.FilterDisplayPanel = FilterDisplayPanel;
GWTableProPlusRef.useFilterValue = useFilterValue;
GWTableProPlusRef.useFilterValueToString = useFilterValueToString;
GWTableProPlusRef.MatchType = MatchType;
GWTableProPlusRef.Order = Order;
GWTableProPlusRef.isOrderTypeValue = isOrderTypeValue;
GWTableProPlusRef.isFilterTypeValue = isFilterTypeValue;

export default GWTableProPlusRef;
